module.exports = __webpack_public_path__ + "static/media/Skip2.05f7a516.png";